import shortid from 'shortid';
import EntityModel from '@/common/models/entity-model';

export default class AlertModel extends EntityModel {
    hydrate({
        id = shortid(),
        title = null,
        message = null,
        type = AlertModel.Types.text,
        params = null,
        condition = null,
        toast = null,
    } = {}) {
        this.id = id;
        this.title = title;
        this.message = message;
        this.type = type;
        this.params = params;

        if (!title && !message) {
            throw new Error('The title or message is required');
        }

        if (!condition || typeof condition !== 'function') {
            throw new Error('Missing field condition');
        }

        this.condition = condition;
        this.toast = toast;
    }

    getPayload() {
        return {
            id: this.id,
            title: this.title,
            message: this.message,
            type: this.type,
            params: this.params,
        };
    }

    static Types = {
        // alert with link
        link: 'link',
        text: 'text',
    };
}
